/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { resetFacetValues, search, selectCollection, toggleFacetValue, updateSort } from '../../actions/RegistryCollectionActions';
import { trackGoogleAnalyticsEvent } from '../../util/trackingHelper';

class FacetButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: false
    };
    this.toggleFacet = this.toggleFacet.bind(this);
  }

  /**
   * On click, toggles whether or not the filter button is selected,
   * and fires an event which has been passed as a prop through the parent (FastFacets)
   * @param {ClickEvent} e
   */
  async toggleFacet() {
    const { facet, facetValue, onToggleFacet, enableCustomCollections } = this.props;
    this.setState({ selected: !this.state.selected });

    trackGoogleAnalyticsEvent('Toggled Facet', {
      category: 'Other Pages',
      action: 'Clicked Top Facets',
      label: facetValue.label
    });

    if (facetValue.values && facetValue.values.length > 0) {
      for (let i = 0; i < facetValue.values.length; i += 1) {
        await onToggleFacet(facet.key, facetValue.values[i], false, enableCustomCollections);
      }
    } else {
      onToggleFacet(facet.key, facetValue.value, false, enableCustomCollections);
    }
  }

  render() {
    const buttonClasses = this.state.selected && !this.props.disabled ? 'fast-facet fast-facet--selected' : 'fast-facet';
    const { label, disabled } = this.props;
    return (
      <button className={buttonClasses} onClick={this.toggleFacet} disabled={disabled}>
        {label}
      </button>
    );
  }
};


FacetButton.propTypes = {
  /** A facet object, looking like: { key:String, label:String, options:Array } */
  facet: PropTypes.shape({}).isRequired,
  /** A facetValue object, one of 'options' above: { children:Array, label:String, result_count:Number, value:String} */
  facetValue: PropTypes.shape({}).isRequired,
  /** The passed-in function that updates the visible registry items using the API */
  onToggleFacet: PropTypes.func.isRequired,
  /** Arrays containing every selected bucket, keyed by facet name */
  selectedFacetValues: PropTypes.shape({}).isRequired,
  /**  */
  enableCustomCollections: PropTypes.bool,
  /**  */
  label: PropTypes.string.isRequired,
  /** Whether or not the button is disabled */
  disabled: PropTypes.bool.isRequired
};


const FastFacets = class FastFacets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      originalFacets: [],
      originalFacetsLoaded: false,
      mobileToggleOpen: false
    };
  }

  render() {
    const { facets, selectedFacetValues, onToggleFacet, sort, onUpdateSort, onMobile, className } = this.props;
    const { originalFacets, originalFacetsLoaded, mobileToggleOpen } = this.state;

    let editedFacets = _.cloneDeep(facets);

    for (let i = 0; i < editedFacets.length; i += 1) {
      let facet = editedFacets[i];
      if (facet.key === 'PRICE') {
        let oldLength = facet.options.length;
        facet.options = facet.options.filter(o => o.value !== 'ZERO_25' && o.value !== 'TWENTYFIVE_50');
        if (facet.options.length < oldLength) {
          facet.options.unshift({
            values: ['ZERO_25', 'TWENTYFIVE_50'],
            value: 'ZERO_50',
            label: 'Under $50'
          })
        }

        let oldLength2 = facet.options.length;
        facet.options = facet.options.filter(o => o.value !== 'ONEFIFTY_200' && o.value !== 'TWOHUNDRED_UP');
        if (facet.options.length < oldLength2) {
          if (facet.options[facet.options.length-1].value === 'GROUP_GIFT') {
            facet.options.splice(facet.options.length - 1, 0, {
              values: ['ONEFIFTY_200', 'TWOHUNDRED_UP'],
              value: 'ONEFIFTY_UP',
              label: '$150+'
            });
          } else {
            facet.options.splice(facet.options.length, 0, {
              values: ['ONEFIFTY_200', 'TWOHUNDRED_UP'],
              value: 'ONEFIFTY_UP',
              label: '$150+'
            });
          }
        }
      }

    }

    const enabledOpts = _.flatten(editedFacets.map(x => x.options));
    const enabledOptKeys = enabledOpts.map(x => x.value);

    // in order for this to work smoothly, we want the facet options to be replaced at the very beginning

    // if 25-50 only: overwrite 25-50 with under 50
    // if under 25 only: overwriter under 25 with under 50
    // if both, ignore under 25 and overwrite 25-50
    let acceptedFacetOptions = [
      'AVAILABLE',
      'ZERO_50',
      'ONEFIFTY_UP',
      'FIFTY_100',
      'ONEHUNDRED_150',
      'GROUP_GIFT',
      'TWO_DAY'
    ];

    if (!originalFacetsLoaded && editedFacets) {
      this.setState({ originalFacets: _.cloneDeep(editedFacets) });
      this.setState({ originalFacetsLoaded: true });
    }

    return (
      <div className={`fast-facet-list ${className}`} style={{ paddingBottom: onMobile && mobileToggleOpen ? '10px' : null }}>
        {/* for each facet available at initialization: */}
        {onMobile ? (
          <button
            className={`mobile-label fast-facet-toggle ${mobileToggleOpen ? 'fast-facet-toggle--selected' : null}`}
            onClick={() => this.setState({ mobileToggleOpen: !mobileToggleOpen })}
          >
            Filter/Sort
            <i className={`fast-facet--toggle-icon zolaicon ${(mobileToggleOpen ? 'zolaicon-chevron-up' : 'zolaicon-chevron-down')}`} />
          </button>
        ) : (
          null
        )}
        <div className={`${mobileToggleOpen || !onMobile ? 'fast-facet-toggled__visible' : 'fast-facet-toggled__hidden'}`}>
          {onMobile ? (
            <div>
              <label className="mobile-label control-label fast-facet--label">Filter</label>
              <br />
            </div>
          ) : (null)}
          <div className="form-inline fast-facet-toggled">
            <div className="fast-facet-buttons">
              {originalFacets.map((f) => {
                // Get a list of the values of the available options.

                return f.options.map((o) => {
                  // If the current option is not available, disable it.
                  let disabled = !_.includes(enabledOptKeys, o.value);
                  const facetOption = o;
                  if (!_.includes(acceptedFacetOptions, facetOption.value)) {
                    return null;
                  }
                  if (facetOption.value === 'TWO_DAY') {
                    facetOption.label = '2-Day Shipping';
                  }
                  // if (disabled) {
                  //   return null;
                  // }
                  return (
                    <FacetButton
                      label={facetOption.label}
                      facetValue={facetOption}
                      selectedFacetValues={selectedFacetValues}
                      facet={f}
                      key={f.key + facetOption.value}
                      onToggleFacet={onToggleFacet}
                      disabled={disabled}
                      onMobile={onMobile}
                    />
                  );
                });
              })}
            </div>
            <div className="form-group sort-control pull-right fast-facet-sort" style={{ width: onMobile ? '100%' : 'auto', marginTop: onMobile ? '10px' : null }}>
              <label htmlFor="public-registry-sort" className={`${onMobile ? 'mobile-label' : null} fast-facet--label fast-facet--sort-label control-label`} style={{marginBottom: onMobile ? '10px' : null, marginTop: onMobile ? '10px' : null}}>Sort by</label>
              {onMobile ? (<br />) : (null)}
              <select id="public-registry-sort" name="public-registry-sort" className="form-control fast-facet-sort-select" onChange={onUpdateSort} value={sort}>
                <option value="">Featured</option>
                <option value="MOST_WANTED" label="Couple's Most Wanted">Couple&apos;s Most Wanted</option>
                <option value="PRICE_ASC" label="Price: Low to High">Price: Low to High</option>
                <option value="PRICE_DESC" label="Price: High to Low">Price: High to Low</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

FastFacets.defaultProps = {
  enableCustomCollections: true,
};

FastFacets.propTypes = {
  facets: PropTypes.arrayOf(PropTypes.shape({})),
  selectedFacetValues: PropTypes.shape({}),
  onToggleFacet: PropTypes.func.isRequired,
  sort: PropTypes.string,
  onUpdateSort: PropTypes.func.isRequired,
  onMobile: PropTypes.bool,
  className: PropTypes.string
};

const mapStateToProps = state => ({
  facets: state.registryCollections.facets,
  /** The values to be passed directly into the filter property of the API search */
  selectedFacetValues: state.registryCollections.selectedFacetValues,
  collectionList: state.registryCollections.collectionList,
  selectedCollectionObjectId: state.registryCollections.selectedCollectionObjectId,
  sort: state.registryCollections.sort,
});

const mapDispatchToProps = dispatch => ({
  onSelectCollection: (collectionObjectId, enableCustomCollections) => {
    dispatch(selectCollection(collectionObjectId));
    dispatch(resetFacetValues());
    dispatch(search(enableCustomCollections));
  },
  onToggleFacet: (facetKey, facetValue, reset = false, enableCustomCollections = true) => {
    // Add google analytics here
    if (reset) { dispatch(resetFacetValues(facetKey)); }
    dispatch(toggleFacetValue(facetKey, facetValue, enableCustomCollections, true));
  },
  onResetFacets: (facetKey, enableCustomCollections) => {
    dispatch(resetFacetValues(facetKey));
    if (!facetKey) {
      dispatch(selectCollection());
      dispatch(updateSort(''));
    }
    dispatch(search(enableCustomCollections));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FastFacets);



// WEBPACK FOOTER //
// ./src/components/registry/RegistryFastFacets.jsx